import type {
  GroupOperator,
  NodePath,
} from '@/components/tree-dnd/tree-dnd-types';
import { useTreeDndStore } from '@/components/tree-dnd/tree-dnd-store';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { cn } from '@/lib/utils';

interface TreeDndGroupOperatorToggleProps {
  path: NodePath;
  operator: GroupOperator;
}

const OPERATORS: GroupOperator[] = ['AND', 'OR'];

export function TreeDndGroupOperatorToggle({
  path,
  operator,
}: TreeDndGroupOperatorToggleProps) {
  const { LL } = useI18nContext();
  const setGroupOperator = useTreeDndStore((state) => state.setGroupOperator);

  const operatorLabels: Record<GroupOperator, () => string> = {
    AND: LL.audiences.details.overview.filterConditions.operators.and,
    OR: LL.audiences.details.overview.filterConditions.operators.or,
  };

  return (
    <ButtonGroup
      aria-label={LL.audiences.filters.groupOperator()}
      className="[&_button]:h-auto [&_button]:rounded-sm [&_button]:px-1.5 [&_button]:py-0.5 [&_button]:text-xs [&_button]:font-semibold [&_button]:uppercase [&_button]:tracking-wider"
      onPointerDown={(event) => event.stopPropagation()}
    >
      {OPERATORS.map((value) => {
        const isActive = operator === value;

        return (
          <Button
            key={value}
            type="button"
            variant={isActive ? 'secondary' : 'ghost'}
            className={cn(
              !isActive &&
                'text-muted-foreground hover:bg-muted/50 hover:text-muted-foreground'
            )}
            onClick={() => setGroupOperator(path, value)}
            aria-pressed={isActive}
          >
            {operatorLabels[value]()}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
